<template>
  <div class="media">
    <a
      href="https://www.facebook.com/piwokrolewskie/"
      class="link"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src="/images/facebook.svg" alt="facebook" class="img" />
    </a>

    <router-link to="/zdrowie" class="link link--bottle">
      ALKOHOL A ZDROWIE
    </router-link>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.media {
  @include center-content(vertically);
  justify-content: flex-end;
}

.img {
  width: 44px;
  min-width: 44px;
  margin-right: 20px;
}

.link {
  color: $text-color;
  text-transform: uppercase;

  &--bottle {
    @include media-down(xl) {
      font-size: 11px;
    }
  }
}
</style>
